import { Modal } from "@mantine/core";

const CustomModal = ({ lockScroll = false, ...props }) => {
  return <Modal lockScroll={lockScroll} {...props} />;
};

export default CustomModal;
